















import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  components: {
  },
  computed: {
    ...mapState("Anzsco", {
      selectedOccupation: "selectedOccupation",
    }),
    ...mapState("RiskProfileTemplate", {
      selectedTemplate: "selectedTemplate",
    }),
    ...mapState('RiskProfile', {
      newRiskProfile: 'newRiskProfile',
    })
  }
})
export default class RiskProfileTemplateSelect extends Vue {

  items: Array<Nullable<Model>> = []

  newRiskProfile!: NewRiskProfile
  selectedTemplate!: Nullable<Model>
  selectedOccupation!: Nullable<Model>

  get selected() {
    if (this.selectedTemplate) {
      return this.selectedTemplate.id || null
    }
    return null
  }

  set selected(id) {
    if (id && id > 0) {
      const item = this.items.filter(item => {
        return item && item.id === id
      }).shift()
      if (item) {
        this.$store.commit('RiskProfileTemplate/SET_SELECTED_TEMPLATE', item)
        this.$store.commit('RiskProfileTemplate/RESET_STATE', ['riskProfileTree'])
      }
    }
    else {
      this.$store.commit('RiskProfileTemplate/RESET_STATE', ['selectedTemplate', 'riskProfileTree'])
    }
  }

  async beforeMount() {
    if (this.selectedOccupation) {
      await this.$store.dispatch('Anzsco/fetchRiskProfileTemplateList', this.selectedOccupation.object_id).then(({ data }) => {
        const payload = data.data
        this.items = payload.risk_profile_templates.map(item => {
          item.title = item.name
          item.subtitle = item.name
          item.content = item.description
          delete item.name, item.description
          return item
        })
      })
      // set first template as the default selected template
      this.$store.commit('RiskProfileTemplate/SET_SELECTED_TEMPLATE', this.items[0])
    }
  }
}
